import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-vehicle-and-loan-mfe';
import { DebugService } from '../../../shared/services/debug.service.js';
import '../../../shared/eligibility-link/eligibility-link.component.js';
import { REFI_VEHICLE_LOAN_CONST } from '../../../shared/constants/app.constants.js';
import { style } from './iconic-loan-warning.style.js';
import { stratum } from '../../../../constants/stratum.js';
import { tags } from '../../../shared/constants/tags.js';

class RefiIconicLoanWarning extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicLoanWarning');
  }

  firstUpdated() {
    stratum.publishTag(TagKey.VIEW_COF_LOAN_ERROR_SCREEN);
  }

  static styles = [style];

  render() {
    return html`
      <refi-track-pageview
        pagename="loan:isCapOneFinanced"
      ></refi-track-pageview>
      <h2>
        We only refinance cars that aren't currently financed by Capital One.
      </h2>
      <div class="refinance-button-container">
        <fs-button
          variant="secondary"
          data-e2e-ref="btnRefiDiffCar"
          @click="${this.goToVehicleLookup}"
        >
          Refinance a Different Car
        </fs-button>
      </div>

      <eligibility-link>See Eligibility Requirements</eligibility-link>
    `;
  }

  goToVehicleLookup() {
    REFI_VEHICLE_LOAN_CONST.TRACK_EVENT(tags.shared.loan.warning.pagename);
    stratum.publishTag(
      TagKey.COF_LOAN_ERROR_SCREEN_CHOOSE_VEHICLE_COF_LOAN_ERROR
    );
    this.dispatchEvent(
      new CustomEvent('reset-flow', {
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define('refi-iconic-loan-warning', RefiIconicLoanWarning);
